import { useEffect, useRef } from 'react';

function AdUnit() {
  var adRef = useRef(null);
  var pushed = useRef(false);

  useEffect(function () {
    if (adRef.current && !pushed.current) {
      try {
        (window.adsbygoogle = window.adsbygoogle || []).push({});
        pushed.current = true;
      } catch (e) {
        // AdSense not loaded yet or ad blocker active
      }
    }
  }, []);

  return (
    <div className="ad-container">
      <ins
        className="adsbygoogle"
        ref={adRef}
        style={{ display: 'block' }}
        data-ad-client="ca-pub-4636071260060895"
        data-ad-slot="8205150111"
        data-ad-format="auto"
        data-full-width-responsive="true"
      />
    </div>
  );
}

export default AdUnit;
